import {Component, forwardRef} from '@angular/core';
import {DictionariesService} from "../../../service";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ViewDictionaryBase} from "../view-dictionary-base";
import {PageOkwed2} from "../../../../../../api/build";

@Component({
  selector: 'app-dict-qref-okwed2',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QrefOkwed2ViewComponent),
    multi: true
  }],
  template: `
    <div class="mb-3 col-3 pl-0 pr-0">
      <label class="form-label">{{title}}
        <app-rq *ngIf="isFieldReq(formControl)" [isReadOnly]="isDisabled"></app-rq>
      </label>
      <app-custom-select *ngIf="dictionary | async as dict; else loading"
                         [items]="dict"
                         [returnOnlyId]="true"
                         [formControl]="formControl"
                         [fieldsFromSearch]="['name']"
                         [isInvalid]="submitted && formControl.errors">
        <ng-template let-item #labelTemplate>
          {{ item.name }}
        </ng-template>
        <ng-template let-item let-search="search" #optionTemplate>
          {{ item.name }}
        </ng-template>
      </app-custom-select>
      <ng-template #loading>
        ...загрузка
      </ng-template>
      <app-valid [logic]="formControl" [submitted]="submitted"></app-valid>
    </div>
  `
})
export class QrefOkwed2ViewComponent extends ViewDictionaryBase<PageOkwed2> {
  getDictionary = this.dictSrv.getQrefOkwed2List();
  constructor(private dictSrv: DictionariesService) {
    super();
  }
}
